import { render, staticRenderFns } from "./MaterialsDialog.vue?vue&type=template&id=7bbfbf42&scoped=true"
import script from "./MaterialsDialog.vue?vue&type=script&lang=js"
export * from "./MaterialsDialog.vue?vue&type=script&lang=js"
import style0 from "./MaterialsDialog.vue?vue&type=style&index=0&id=7bbfbf42&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bbfbf42",
  null
  
)

export default component.exports